const SGC_COLORS = {
  secondary: "#00973C",
  promoBackground: "#F3F7F6",
  savingBackground: "#FCFFE6",
  savingLabel: "#FFFB8F",
  discountRed: "#F5222D",
  flashSaleBackground: "#FFCCC7",
  flashSaleSpark: "#FFD591",
  tooltipBackground: "#E6F5ED"
};

export { SGC_COLORS };
